/*
 *
 * TeamAnalysis reducer
 *
 */

import { fromJS } from "immutable"
import {
  GET_DRILLDOWN_DIVISIONS_WATCHER,
  GET_DRILLDOWN_DIVISIONS_SUCCESS,
  GET_DIMENSIONS_WATCHER,
  GET_DIMENSIONS_SUCCESS,
  GET_DRILLDOWN_DIVISIONS_FAILED,
  GET_GRAPHIC_BAR_WATCHER,
  GET_GRAPHIC_BAR_SUCCESS,
  GET_GRAPHIC_BAR_FAILED,
  GET_MEASURE_COLOR_RANGE_SUCCESS,
} from "./constants"

export const initialState = fromJS({
  isLoading: false,
  divisions: [],
  dimensions: [],
  levels: [],
  divisions_drilldown: [],
  metric: {},
  teams: [],
  divisions_filter: [],
  graphicBars: [],
  isLoadingGraphicBars: true,
  show_history: false,
  switchMoreDimensions: false,
  measureColorRange: null,
})

function teamAnalysisReducer(state = initialState, action) {
  switch (action.type) {
    case GET_GRAPHIC_BAR_WATCHER:
      return state.set("graphicBars", []).set("isLoadingGraphicBars", true)
    case GET_GRAPHIC_BAR_SUCCESS:
      return state
        .set("graphicBars", action.payload)
        .set("isLoadingGraphicBars", false)
    case GET_GRAPHIC_BAR_FAILED:
      return state.set("graphicBars", []).set("isLoadingGraphicBars", false)

    case GET_DRILLDOWN_DIVISIONS_WATCHER:
      return state
        .set("isLoading", true)
        .set("divisions_drilldown", [])
        .set("metric", {})
        .set("divisions", [])
        .set("measureInfo", {})
    case GET_DRILLDOWN_DIVISIONS_SUCCESS:
      return state
        .set("isLoading", false)
        .set(
          "divisions_filter",
          Array.isArray(state.get("divisions_filter"))
            ? state.get("divisions_filter").length === 0
              ? action.payload.data
              : state.get("divisions_filter")
            : action.payload.data
        )
        .set("divisions", action.payload.data)
        .set("divisions_drilldown", action.payload.data_drilldown)
        .set("metric", action.payload.metric)
        .set(
          "levels",
          Array.isArray(state.get("levels"))
            ? state.get("levels").length === 0
              ? action.payload.levels
              : state.get("levels")
            : action.payload.levels
        )
        .set("show_history", action.payload.show_history)
        .set("switchMoreDimensions", action.payload.switchMoreDimensions)
        .set("measureInfo", action.payload.measureInfo)

    case GET_DIMENSIONS_WATCHER:
      return state.set("dimensions", [])
    case GET_DRILLDOWN_DIVISIONS_FAILED:
      return state
        .set("isLoading", false)
        .set(
          "divisions_filter",
          Array.isArray(state.get("divisions_filter"))
            ? state.get("divisions_filter").length === 0
              ? action.payload.data
              : state.get("divisions_filter")
            : action.payload.data
        )
        .set("divisions", [])
        .set("divisions_drilldown", [])
        .set("metric", {})
        .set("show_history", false)
        .set("switchMoreDimensions", false)

    case GET_DIMENSIONS_SUCCESS:
      return state.set("dimensions", action.payload.dimensions)

    case GET_MEASURE_COLOR_RANGE_SUCCESS:
      return state.set("measureColorRange", action.payload.report_color_range)
    default:
      return state
  }
}

export default teamAnalysisReducer
